import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import type { SpecsFormOption } from "../../specsForm/types";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class ProductVersionDecorationTypeModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    name: { label: "Name", fieldType: "autocomplete", options: [] },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  name!: string;
  extra!: Record<string, unknown>;
  private nameOptions: SpecsFormOption[] = [];

  constructor() {
    super();
    this.defineObservableValue("name", "");
    this.defineObservableValue("extra", {});
  }

  setNameOptions(options: SpecsFormOption[]) {
    this.nameOptions = options;
    return this;
  }

  getAutoFormFieldMetadata(key: string) {
    if (key !== "name") {
      return null;
    }

    return {
      ...ProductVersionDecorationTypeModel.autoFormFields.name,
      options: this.nameOptions,
    };
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product decoration type metadata");
    this.name = readString(source, "name");
    this.extra = splitKnown(source, ["name"]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.name ? { name: this.name } : {}),
    };
  }
}
